import { render, staticRenderFns } from "./SmTableReservesPayments.vue?vue&type=template&id=b729b624&scoped=true&"
import script from "./SmTableReservesPayments.vue?vue&type=script&lang=ts&"
export * from "./SmTableReservesPayments.vue?vue&type=script&lang=ts&"
import style0 from "./SmTableReservesPayments.vue?vue&type=style&index=0&id=b729b624&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b729b624",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VDivider,VRow})
